'use client';

import { memo, useState } from 'react';
import { BaseLineDown } from '@/app/components/icons/BaseLineDown';
import { BaseLineUp } from '@/app/components/icons/BaseLineUp';
import type { FaqCategory } from '@/app/types';
import { cn } from '@/app/utils';
import FaqContent from './FAQContent';

interface MobileProps {
  categories: FaqCategory[];
}

export const Mobile = memo(({ categories }: MobileProps) => {
  const [selectedCategory, setSelectedCategory] = useState<FaqCategory | null>(categories[0]);

  const handleCategoryClick = (slug: string) => {
    const category = categories.find((cat) => cat.slug === slug);
    if (category) {
      setSelectedCategory(category);
    }
  };

  return (
    <div className="mb-[48px] hidden w-full grid-cols-1 gap-3 px-4 md:grid">
      {categories.map((category) => (
        <div className="gap-3" key={category.slug} onClick={() => handleCategoryClick(category.slug)}>
          <div
            className={cn(
              'flex flex-col items-start gap-3 self-stretch rounded-2xl px-6 py-4',
              selectedCategory?.slug === category.slug ? 'bg-white/[.16]' : 'bg-white/[.10]',
            )}
          >
            <div className="flex items-center justify-between self-stretch">
              <div className="flex w-[385.5px] items-center gap-2 font-semibold text-white leading-7">
                {category.category}
              </div>
              {selectedCategory?.slug === category.slug ? (
                <BaseLineUp className="h-6 w-6 text-white" />
              ) : (
                <BaseLineDown className="h-6 w-6 text-white opacity-40" />
              )}
            </div>
          </div>

          {selectedCategory?.slug === category.slug && (
            <div className="mt-3 flex flex-col items-start gap-10 self-stretch rounded-2xl bg-white/[.16] py-4 pr-6 pl-4">
              {category.faqs?.map((faq) => (
                <FaqContent key={faq.question} faq={faq} />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
});
